// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"0e0a9db599f511de","node_modules_dompurify_dist_purify_js":"2ffb35e2a1f33b4f","node_modules_canvg_lib_index_es_js":"b30e122cccd7af15","node_modules_quill_dist_quill_js":"fd7fa7cf5d416df7"}[chunkId] + ".js";
};